import './style.css'

const Footer = () => {
    return (
        <footer className="footer">
            <div className="footer-container container">
                <div className="footer-leftside">
                    <div className="textblock">
                        <p>®seimoro development</p>
                        <p>all rights reserved</p>
                    </div>
                </div>
                <div className="footer-rightside">
                    <div className="textblock">
                        <p>for employers and HR's</p>
                        <p>Q&A</p>
                        <p>terms & agreement</p>
                    </div>
                </div>
            </div>
        </footer>
    );
}

export default Footer;